
import { defineComponent } from 'vue';
import { PersianDate } from '@/Utils/persian-date';
import CustomButton from '@/components/vuetifyComponents/CustomButton.vue';
import router from '@/router';

export default defineComponent({
    name: "UsersTableComponent",

    props: ["users"],

    components: { CustomButton },

    data() {
        return {
            persianDateConverter: new PersianDate(),
            moreOptions: {
                show: false,
                userId: ""
            },
            tableHeaders: [
                "نام و نام خانوادگی",
                "شماره همراه",
                "موجودی (تومان)",
                "تراکنش‌ها",
                "پیام",
                "مشخصات"
            ],
            options: [
                {
                    title: "گزینه ها",
                    icon: require("@/assets/icons/more.svg"),
                    path: "options"
                }
            ],
        }
    },

    methods: {
        persianDate(utcDateTime: string): string {
            return this.persianDateConverter.convert(utcDateTime, true);
        },

        FormatPersianAmount(amount: number | string): string {
            // Convert to number if it's a string
            const num = typeof amount === 'string' ? parseFloat(amount) : amount;

            if (isNaN(num)) {
                return "مبلغ نا معتبر"; // Or handle the error as you prefer
            }

            const parts = num.toString().split(".");
            const integerPart = parts[0];
            const fractionalPart = parts[1] || '';

            // Apply thousands separator to the integer part
            const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            // Combine integer and fractional parts
            const formattedAmount = fractionalPart ? `${formattedIntegerPart}.${fractionalPart}` : formattedIntegerPart;

            return formattedAmount;
        },

        formatPhone(phone: string): string {
            return phone?.startsWith('0098') ? `0${phone.slice(4)}` : phone || '—';
        },

        handleOption(path: string, userId: string): void {
            const option = {
                path: path,
                userId: userId
            }
            this.moreOptions.userId = userId;
            this.moreOptions.show = !this.moreOptions.show;
            this.$emit("option", option);
        },

        handleToggleStatus(credit: any): void {
            const data = {
                creditId: credit._id,
                block: !credit.block
            }
            this.$emit("toggle-credit-block", data);
        },

        toggleAccessAccount(userId: string, block: boolean): void {
            this.$emit("access-account", { userId: userId, block: !block });
        },

        toggleUserCashout(userId: string, cashout: boolean): void {
            this.$emit("user-cashout", { userId: userId, cashout: !cashout });
        },

        togglePanelAccess(userId: string, access: boolean): void {
            this.$emit("panel-access", { userId: userId, access: !access });
        },

        handleUserOption(userId: string, path: string): void {
            this.$emit("user-option", { userId: userId, path: path });
        },

        showUserTransactions(userId: string): void {
            router.push({ name: "UserTransactions", query: { user: userId } });
        },

        sendUserNotification(userId: string): void {
            router.push({ name: "Notifications", query: { user: userId } });
        },

        showUserWithdrawals(userId: string): void {
            router.push({ name: "UserWithdrawals", query: { user: userId } });
        }
    },
})
